
export interface CertTestVO {
    name: string;
    testSetName: string;
    createdTimestamp: string;
    testGroups: CertTestGroupVO[];
}

export interface CertTestGroupVO {
    name: string;
    testCases: CertTestCaseVO[];
}

export interface CertTestCaseVO {
    testID: string;
    expectedRequests: string;
    title: string;
    description: string;
    status: string;
    error: string;
    ignored: boolean;
    startedDatetime: string;
    initialMedicineCardVersion: number;
    ignoreReason: string;
    params: CertTestParameterVO[];
}

export interface CertTestParameterVO {
    name: string;
    value: string;
    description: string;
    regex: string;
    validationMessage: string;
}

export interface CertTestGroupsVO {
    testGroups: string[];
}

export interface CertTestCaseRapportVO {
    testID: string;
    title: string;
    rapport: string[];
}

export interface CertTestGroupRapportVO {
    name: string;
    testCases: CertTestCaseRapportVO[];
}

export interface CertTestRapportVO {
    name: string;
    testGroups: CertTestGroupRapportVO[];
}

export interface WhitelistingVO {
    systemOwnerName: string;
    systemName: string;
    systemVersion: string;
    fmkVersion: string;
    eoVersion: string;
    porVersion: string;
}

export class TestCaseStatus {
    static READY = "READY";
    static STARTED = "STARTED";
    static EXPIRED = "EXPIRED";
    static FINISHED = "FINISHED";
}

export enum TestSet {
    FMK_144_GODKENDELSESTEST,
    FMK_144E1_GODKENDELSESTEST,
    FMK_144E2_GODKENDELSESTEST,
    FMK_146_GODKENDELSESTEST,
    FMK_146E2_GODKENDELSESTEST
}

export class TestSetUtil {
    public static toString(testSet: TestSet) {
        switch (testSet) {
            case TestSet.FMK_144_GODKENDELSESTEST:
                return "FMK 1.4.4 Godkendelsestest";
            case TestSet.FMK_144E1_GODKENDELSESTEST:
                return "FMK 1.4.4.E1 Godkendelsestest";
            case TestSet.FMK_144E2_GODKENDELSESTEST:
                return "FMK 1.4.4.E2 Godkendelsestest";
            case TestSet.FMK_146_GODKENDELSESTEST:
                return "FMK 1.4.6 Godkendelsestest";
            case TestSet.FMK_146E2_GODKENDELSESTEST:
                return "FMK 1.4.6.E2 Godkendelsestest";
        }
    }
}

